import React, { useEffect, useState, Fragment, useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import { isNilEmpty } from 'Utils'
import BuildingList from './components/BuildingList'
import {
  _BuildingListContainer,
  _ClickableFlex,
  _BuildingAutoComplete,
} from './styles'

const showMoreLimit = 4
const confirmMessageElem = (
  <Fragment>
    <div>Deleting last building will delete this alert</div>
    <div>{'You can\'t undo this action.'}</div>
  </Fragment>
)
const ManageBuildings = (
  {
    alert,
    buildings,
    alertId,
    buildingIds,
    loadBuildings,
    updateAlert,
    handleDeleteAlert,
    mobileBrowser,
  },
) => {
  const [showAllBuildings, toggleShowAllBuildings] = useState(false)
  const [addBuildingActive, toggleAddBuilding] = useState(false)
  const [deleteBuildingIds, updateDeleteBuildingIds] = useState({})

  // need to keep the original until user hits save button
  useEffect(
    () => {
      updateDeleteBuildingIds({})
    },
    [buildings],
  )

  // on alert update reset state
  useEffect(
    () => {
      updateDeleteBuildingIds({})
    },
    [alert],
  )
  useEffect(
    () => {
      loadBuildings({ buildingIds, alertId })
    },
    [buildingIds],
  )
  const containerRef = useRef()

  const manageBuildingClick = useCallback(() => {
    if(mobileBrowser) {
      containerRef.current.scrollIntoView({ behavior: 'smooth' })
    }
    toggleAddBuilding(!addBuildingActive)
    toggleShowAllBuildings(true)
  })

  const showAllClick = useCallback(() => {
    toggleShowAllBuildings(!showAllBuildings)
  })
  function handleLeadSearchCloseIconClick() {
    toggleAddBuilding(false)
  }
  function deleteBuilding(building) {
    if(buildingIds.length === 1) {
      return handleDeleteAlert(confirmMessageElem)
    }
    const newBuildingIds = buildingIds.filter(buildingId => buildingId !== building.id)
    updateDeleteBuildingIds({
      ...deleteBuildingIds,
      [building.id]: building.name,
    })
    updateAlert(alert, {
      name: 'building_ids',
      newValue: newBuildingIds,
    })
  }

  function handleBuildingSelect(selectedBuilding) {
    // preventing duplicate ids
    if(!buildings || !buildings[selectedBuilding.id]) {
      updateAlert(alert, {
        name: 'building_ids',
        newValue: [selectedBuilding.id, ...alert.building_ids],
      })
    }
  }

  const alertBuildingsCount = buildings
    ? Object.keys(buildings).length
    : 0
  const hasMoreThanLimit = alertBuildingsCount > showMoreLimit

  const showLimit = !buildings
    ? null
    : showAllBuildings ? alertBuildingsCount : showMoreLimit

  return (
    <div ref={containerRef}>
      {
        addBuildingActive &&
        <div>
          <_BuildingAutoComplete
            data-test-id="addBuildingAutoComplete"
            handleItemSelect={handleBuildingSelect}
            placeHolder={'Add Building'}
            showClose
            onCloseClick={handleLeadSearchCloseIconClick}
          />
        </div>
      }
      <_BuildingListContainer>
        {
          !isNilEmpty(buildings) &&
          <BuildingList
            buildingList={buildings}
            showLimit={showLimit}
            deleteBuildingIds={deleteBuildingIds}
            onDelete={deleteBuilding}
            sourcePage="Manage Buildings"
          />
        }
      </_BuildingListContainer>
      <_ClickableFlex align={'center'}>
        <div data-test-id="addBuildingBtn" onClick={manageBuildingClick}>
          Add Buildings
        </div>
        {
          hasMoreThanLimit &&
          <Fragment>
            <div>|</div>
            <div data-test-id="showMoreToggleBtn" onClick={showAllClick}>
              Show
              {showAllBuildings ? ' Less' : ' All'}{' '}
              {hasMoreThanLimit && !showAllBuildings
                ? alertBuildingsCount
                : ''}
              {' '}
              Buildings
            </div>
          </Fragment>
        }
      </_ClickableFlex>
    </div>
  )
}
ManageBuildings.defaultProps = {
  loadBuildings: () => {},
}
ManageBuildings.propTypes = {
  alert: PropTypes.shape({
    building_ids: PropTypes.arrayOf(PropTypes.number),
  }),
  buildings: PropTypes.objectOf(
    PropTypes.shape({
      photos: PropTypes.arrayOf(PropTypes.shape({})),
    }),
  ),
  loadBuildings: PropTypes.func,
  updateAlert: PropTypes.func,
  handleDeleteAlert: PropTypes.func,
  alertId: PropTypes.string,
  buildingIds: PropTypes.arrayOf(PropTypes.number),
  mobileBrowser: PropTypes.bool,
}

export default ManageBuildings
